import { ExtraErrorData, CaptureConsole, ReportingObserver, Offline } from '@sentry/integrations';
import { Integrations } from '@sentry/tracing';
import { ignoreGDKErrors } from './ignoreGDKErrors';
const getIntegrations = () => [
    new ExtraErrorData(),
    new Integrations.BrowserTracing(),
    new ReportingObserver(),
    new CaptureConsole({ levels: ['error'] }),
    new Offline()
];
export const getRegisterConfig = ({ dsn, release, stage, ignoreCodes, injected }) => ({
    integrations: getIntegrations(),
    dsn,
    environment: stage,
    release,
    attachStacktrace: true,
    beforeSend: ignoreCodes ? ignoreGDKErrors(ignoreCodes) : undefined,
    ...injected,
});
//# sourceMappingURL=registerSentry.js.map